module.exports = __webpack_public_path__ + "49262eb3cfba9eac6a9d52bea173d73f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/dreyfus.png
// module id = 1428
// module chunks = 0